import i18n, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import grunndataSelectorNb from "@/i18n/resources/nb/grunndataSelector.json";
import inspectionPointNb from "@/i18n/resources/nb/inspectionPoint.json";
import mapNb from "@/i18n/resources/nb/map.json";

const resources: Resource = {
  nb: {
    grunndataSelector: grunndataSelectorNb,
    inspectionPoint: inspectionPointNb,
    map: mapNb,
  },
};

if (!i18n.isInitialized) {
  await i18n.use(initReactI18next).init({
    resources,
    lng: "nb",
    fallbackLng: "nb",
    defaultNS: "grunndataSelector",
    ns: ["grunndataSelector", "inspectionPoint", "map"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
}

export default i18n;
